import { Link } from "react-router-dom";
import { ArrowRight, Zap, Home, Layers, Square, Wrench, RefreshCw, Search, Wind, AlertTriangle, Building } from "lucide-react";

const iconMap = {
  Zap,
  Home,
  Layers,
  Square,
  Wrench,
  RefreshCw,
  Search,
  Wind,
  AlertTriangle,
  Building,
};

// Map service slugs to their dedicated pages
const serviceRoutes: Record<string, string> = {
  "metal-roofing": "/services/metal-roofing",
  "tile-roofing": "/services/tile-roofing",
  "shingle-roofing": "/services/shingle-roofing",
  "flat-roof": "/services/flat-roofing",
  "roof-inspection": "/services/roof-inspection",
  "emergency-roof-repair": "/emergency",
  "roof-repair": "/quick-estimate",
  "roof-replacement": "/quick-estimate",
  "hurricane-damage": "/services/roof-inspection",
  "commercial-roofing": "/services/flat-roofing",
};

interface ServiceCardProps {
  name: string;
  slug: string;
  icon: string;
  description: string;
  href?: string;
}

const ServiceCard = ({ name, slug, icon, description, href }: ServiceCardProps) => {
  const IconComponent = iconMap[icon as keyof typeof iconMap] || Wrench;
  // Use explicit href, then check serviceRoutes, then fallback to services anchor
  const linkHref = href || serviceRoutes[slug] || `/services#${slug}`;

  return (
    <Link
      to={linkHref}
      className="group bg-card rounded-2xl p-6 shadow-soft hover:shadow-card transition-all duration-300 hover:-translate-y-1 hover:ring-2 hover:ring-accent/30"
    >
      <div className="w-14 h-14 rounded-xl bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
        <IconComponent className="w-7 h-7 text-accent" />
      </div>
      
      <h3 className="text-lg font-heading font-bold text-foreground mb-2 group-hover:text-accent transition-colors">
        {name}
      </h3>
      
      <p className="text-muted-foreground text-sm leading-relaxed mb-4">
        {description}
      </p>
      
      <div className="flex items-center gap-2 text-accent font-semibold text-sm">
        Learn More
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </div>
    </Link>
  );
};

export default ServiceCard;
